import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import { useStores } from 'hooks';
import BadgeInput from 'components/project/ClerkScreen/FloorBidderBadge/BadgeInput';
import { Container, Label } from './Styles';

export const FloorBidderBadge = ({ inputRef }) => {
  const {
    BidStore: {
      initialClickIsNoSale,
      floorBidderBadgeIsInvalid,
      shouldDisableFloorBidderBadge,
      getFloorBidderBadgePlaceholderText,
      auction,
      laneSuspended,
    },
    ProviderStore: { getProviderSettingByKey },
    UIStore: {
      handleFloorBidderBadgeKeyUp,
      handleFloorBidderBadgeChange,
      handleFloorBidderBadgeFocus,
    },
  } = useStores();

  const { floorBidderBadge } = auction;

  const showBidderBadge = parseInt(getProviderSettingByKey('ShowBadgeNumber')) > 0;

  useEffect(() => {
    if (auction.focusOnFloorBidderBadge) {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
    return () => null;
  }, [shouldDisableFloorBidderBadge, auction.focusOnFloorBidderBadge, inputRef]);

  return (
    <>
      {showBidderBadge && (
        <Container
          confirming={laneSuspended}
          isNoSale={initialClickIsNoSale}
          invalid={floorBidderBadgeIsInvalid}
          disabled={shouldDisableFloorBidderBadge}
        >
          <Label>Floor Bidder Badge</Label>
          <BadgeInput
            ref={inputRef}
            disabled={shouldDisableFloorBidderBadge}
            tabIndex={shouldDisableFloorBidderBadge ? 6 : 9}
            placeholderText={getFloorBidderBadgePlaceholderText}
            onFocus={handleFloorBidderBadgeFocus}
            onKeyUp={handleFloorBidderBadgeKeyUp}
            onChange={handleFloorBidderBadgeChange}
            value={floorBidderBadge || ''}
          />
        </Container>
      )}
    </>
  );
};

FloorBidderBadge.propTypes = {
  inputRef: PropTypes.object,
};

FloorBidderBadge.defaultProps = {
  inputRef: null,
};

export default observer(FloorBidderBadge);
